<template>
  <div>
    <div class="custom-div ml-3 mr-3 pt-1">
      <div @click="show = !show" class="circular-div ml-3">
        <em
          class="fas"
          :class="{
            'fa-chevron-circle-down': show,
            'fa-chevron-circle-right': !show,
            'icon-color': true,
            'center-icon': true
          }"
        >
        </em>
      </div>
      <div class="ml-2">
        <p class="p-white">{{ title }}</p>
      </div>
    </div>
    <div>
      <slot v-if="show" />
    </div>
  </div>
</template>

<script>
export default {
  name: "CollapsibleContainer",
  meta: {
    description: "Componente común para ser usado como contenedor.",
    slots: {
      default: {
        type: "component",
        valid: []
      }
    }
  },
  props: {
    title: {
      type: String,
      default: "",
      meta: {
        description: "Titulo del CollapsibleContainer",
        example: "Evaluación inicial"
      }
    },
    collapse: {
      type: Boolean,
      default: false,
      meta: {
        description: "Indica si el contenedor se encuentra colapsado o no",
        example: "true"
      }
    }
  },
  data() {
    return {
      show: true
    };
  },
  watch: {
    collapse: {
      handler(val) {
        this.show = !val;
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
.custom-div {
  border-radius: 5px;
  background-color: #3f5b60;
  height: 36px; /* Ajusta la altura según tus necesidades */
  width: 100%; /* O ajusta el ancho según tus necesidades */
  display: flex;
}

.p-white {
  color: #ffffff;
}

.icon-color {
  color: #2cb782;
  margin-top: 3px;
}

.circular-div {
  width: 27px;
  height: 27px;
  margin-top: 1px;
  background-color: white;
  border-radius: 50%; /* Esto crea un div circular */
  display: flex; /* Usar flexbox para centrar vertical y horizontalmente */
  align-items: center; /* Centrar verticalmente */
  justify-content: center; /* Centrar horizontalmente */
}

.center-icon {
  /* Añadir cualquier estilo adicional necesario para el ícono */
  font-size: 22px;
  margin-top: 1px;
  /* Ajustar el tamaño del ícono según tus necesidades */
}
.content-slot {
  margin-left: 10px; /* Agregar margen de 10px al contenido del slot */
}
</style>
